import script from "./TransferOwnershipDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferOwnershipDialog.vue?vue&type=script&setup=true&lang=js"

import "./TransferOwnershipDialog.vue?vue&type=style&index=0&id=519c336a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519c336a"]])

export default __exports__